import React, { createContext } from "react";
const ClientVideoContext = createContext();
export default ClientVideoContext;
